export const electronDownloadVersion = process.env.REACT_APP_ELECTRON_DOWNLOAD_VERSION!;
export const electronMacDownloadLink = process.env.REACT_APP_ELECTRON_MAC_DOWNLOAD_LINK!;
export const electronWinDownloadLink = process.env.REACT_APP_ELECTRON_WIN_DOWNLOAD_LINK!;
export const electronDebDownloadLink = process.env.REACT_APP_ELECTRON_LINUX_DOWNLOAD_LINK!;
export const discoverUrl = process.env.REACT_APP_DISCOVER_URL!;
export const IDLE_TIMEOUT_SECONDS = 15000;
export const enable8X8TokenLogin = process.env.REACT_APP_ENABLE_8X8_TOKEN_LOGIN !== "false";
export const disableOauthLogin = process.env.REACT_APP_DISABLE_OAUTH_LOGIN === "true";
export const debugChaletLoginUrl = process.env.REACT_APP_DEBUG_CHALET_LOGIN_URL;
export const ssoClientId = process.env.REACT_APP_SSO_CLIENT_ID || "chalet";
